import React from "react";
import "../PptViewer.css";

const PresentationSlides = () => {
  // PPT files data
  const pptFiles = [
   {
      id: 1,
      title: "Polynomials",
      desc: "A comprehensive overview of polynomial concepts.",
      url: "https://flippedlearning.neinus.com/ppt/Polynomials.pptx",
    },
    {
      id: 2,
      title: "Remainder Theorem",
      desc: "Learn how to apply the remainder theorem with examples.",
      url: "https://flippedlearning.neinus.com/ppt/Remainder-Theorem.pptx",
    },
    {
      id: 3,
      title: "Algebraic Identities",
      desc: "Understand and apply key algebraic identities with examples.",
      url: "https://flippedlearning.neinus.com/ppt/Algebraic-Identities.pptx",
    },
     {
      id: 4,
      title: "Factorisation - Breaking Expressions into Simpler Parts",
      desc: "Learn how to simplify and factorise complex expressions.",
      url: "https://flippedlearning.neinus.com/ppt/Factorisation-Breaking-Expressions-into-Simpler-Parts.pptx",
    },
    {
      id: 5,
      title: "Division of Polynomials",
      desc: "Step-by-step guide to dividing polynomials effectively.",
      url: "https://flippedlearning.neinus.com/ppt/Division-of-Polynomials.pptx",
    },
    {
      id: 6,
      title: "Greatest Common Divisor (GCD)",
      desc: "Understand how to find GCD of polynomials and numbers.",
      url: "https://flippedlearning.neinus.com/ppt/Greatest-Common-Divisor-GCD.pptx",
    },
    
    {
      id: 6,
      title: "Polynomials - Mastering the Foundations",
      desc: "Deep dive into the foundational concepts of polynomials.",
      url: "https://flippedlearning.neinus.com/ppt/Polynomials-Mastering-the-Foundations.pptx",
    },
   
    
  ];

  return (
    <section className="ppt-section">
      <h3>Presentation Slides</h3>
      <div className="ppt-grid">
        {pptFiles.map((ppt) => (
          <div key={ppt.id} className="ppt-card">
            <div className="ppt-info">
              <h3>{ppt.title}</h3>
              <p>{ppt.desc}</p>
            </div>

            <div className="ppt-actions">
              <button
                onClick={() => window.open(ppt.url, "_blank")}
                className="view-btn"
              >
                View
              </button>
              <a href={ppt.url} download className="download-btn">
                Download
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PresentationSlides;
